import { Skeleton } from '@mui/material';
import clsx from 'clsx';

import Tooltip from '@components/tooltip/Tooltip';
import { SwitchInterface } from '@types';

const Switch: React.FC<SwitchInterface> = ({
  handleClick,
  value = true,
  disabled = false,
  className,
  label,
  loading,
  hasAccess = true,
  labelClassName,
  testId,
  tooltipText,
  buttonClassName,
  buttonClassNames,
  thumbClassName,
  switchVariantClassName,
  switchPosition = 'right',
  ...props
}) => {
  const toggleSwitch = () => {
    if (!disabled && !loading) {
      handleClick(!value);
    }
  };

  const containerClassNames = 'flex h-5 items-center justify-center';
  const baseButtonClassNames = clsx(
    'flex h-5 w-9 items-center rounded-3xl p-1',
    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
  );

  const buttonVariantStyles = value
    ? 'bg-cofeePrimary6'
    : 'bg-cofeeGreyBlue300';

  const switchVariantStyles = value
    ? 'translate-x-[13px] bg-cofeeNeutral1'
    : '-translate-x-[1px] bg-cofeeNeutral1';

  const switchClassNames = 'h-4 w-4 rounded-3xl duration-300 ease-in-out';

  return loading ? (
    <Skeleton animation="wave" width={86} />
  ) : (
    <div className={clsx(containerClassNames, className)}>
      {label && switchPosition === 'right' && (
        <span
          className={clsx(
            `mr-2 text-base ${labelClassName}`,
            value ? 'text-primary' : 'text-grey80'
          )}
        >
          {label}
        </span>
      )}
      {hasAccess && (
        <button
          type="button"
          className={clsx(
            baseButtonClassNames,
            buttonVariantStyles,
            buttonClassName,
            buttonClassNames
          )}
          onClick={toggleSwitch}
          data-tooltip-id={`${testId}-switch`}
          data-testid={`${testId}-switch-button`}
          {...props}
        >
          <div
            className={clsx(
              switchClassNames,
              switchVariantStyles,
              switchVariantClassName,
              thumbClassName
            )}
          />
        </button>
      )}
      {label && switchPosition === 'left' && (
        <span
          className={clsx(
            `ml-2 text-base ${labelClassName}`,
            value ? 'text-primary' : 'text-grey80'
          )}
        >
          {label}
        </span>
      )}
      <Tooltip
        id={`${testId}-switch`}
        type="text"
        tooltipText={tooltipText}
        className="max-w-120 leading-5"
        place="top-start"
      />
    </div>
  );
};

export default Switch;
